export default {
  SIMULATION_CONDITION: 'simulationCondition',
  SIMULATION_DATA: 'simulationData',
};
